<template>
  <div class="container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row justify="center" dense>
     <v-col cols="12" sm="8" md="8">
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Promote Student [Selected #{{selectedTasks.length}}]</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_ay_data"
            return-object
            :items="ay_std_div_list"
            item-text="ay"
            label="Academic Year"
            outlined
            @change="getStd()"
            @click="putnull"
            persistent-hint
          />
        </v-col>
        <v-col sm="3" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_std_data"
            return-object
            :items="std_div_list"
            item-text="std"
            label="Standard"
            outlined
            @change="getDiv"
            @click="putnull"
            persistent-hint
          />
        </v-col>
        <v-col sm="3" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="div"
            return-object
            :items="div_list"
            item-text="div_name"
            label="Division"
            outlined
            @click="putnull"
            persistent-hint
          />
        </v-col>

        <v-col sm="2" v-if="sel_ay_data && sel_std_data">
          <v-btn
            class="mt-6 button"
            @click="getStudents()"
            :loading="fetch_loader"
            >Fetch</v-btn
          >
        </v-col>
      </v-row>
      <span v-if="mainList != '' && mainList != null">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-row justify="end">
             <v-col sm="3" v-if="std_div_list != null">          
          <v-autocomplete
            color="#0F2027"
            dense
            rounded            
            v-model="selectedStandard"
            return-object
            :items="std_div_list"
            item-text="std"
            label="Standard"
            outlined
            @change="applyStandardToMainList"
            @click="putnull"
            persistent-hint
          />
        </v-col>
        <v-col sm="3" v-if="div_list != null">          
          <v-autocomplete
            color="#0F2027"
            dense
            rounded            
            v-model="selectedDivision"
            return-object
            :items="div_list"
            item-text="div_name" 
            label="Division"           
            outlined
            @change="applyDivisionToMainList"
            @click="putnull"
            persistent-hint
          />
        </v-col> 
          </v-row>
          <v-data-table            
            v-if="mainList.length > 0"
            :headers="headers"
            :items="mainList"
            :search="search"
            class="elevation-1"
            v-model="selectedTasks"
            :single-select="singleSelect"
            item-key="ldiv"
            :items-per-page="-1"
            > 
            
          <template v-slot:[`item.sel_std_data`]="{ item }">
        <v-select
          v-model="item.sel_std_data"
          :items="std_div_list"
          item-text="std"
          placeholder="Standard"
          solo 
          comfortable       
        ></v-select>
      </template>
      <template v-slot:[`item.div`]="{ item }">
        <v-select
          v-model="item.div"
          :items="div_list"
          item-text="div_name"
          placeholder="Division"
          solo 
          comfortable          
        ></v-select></template>  
          </v-data-table>
        </v-card>
      </span>
    </v-card>
    </v-col>    
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
  data: () => ({
    headers: [
      { text: "Roll Number", value: "rollnumber", align: "center" },
      { text: "Student Name", value: "studentname", align: "center" },
      { text: "Registration Number", value: "grnumber", align: "center" },
      { text: "Standard", value: "sel_std_data", align: "center", editable: true },
      { text: "Division", value: "div", align: "center", editable: true },
      //{ text: "Is Promoted", value: "ispromoted", align: "center" },
    ],
    singleSelect: false,
    fetch_loader: false,
    mainList: [],new_list:[],
    ay_std_div_list: null,
    std_div_list: null,
    standard_list:null,standard:"",divoff_list:null,div_off:"",ay_list:null,academicyear:"",show_card:false,
    selectedTasks: [],
    overlay: false,
    div_list: null,
    sel_std_data: null,
    selectedStandard: null,
    selectedDivision: null,
    divoff: "",
    studentinfo: "",
    ay: "",
    standard: "",
    division: "",
    dayno: "",
    search: "",
    atten_date: "",
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    editedIndex: {
      rollnumber: "",
      studentname: "",
      grnumber: "",
      totalpresent: "",
      ldiv: "",
    },
    nowDate: new Date().toISOString().slice(0, 10),
  }),

  mounted() {
    this.onload();
  },
  methods: {
    applyStandardToMainList() {          
  if (this.selectedStandard) {          
    this.mainList = this.mainList.map(student => {
      return { ...student, sel_std_data: this.selectedStandard.std };
    });
  }
},    
applyDivisionToMainList() {        
  if (this.selectedDivision) {          
    this.mainList = this.mainList.map(student => {
      return { ...student, div: this.selectedDivision.div_name };
    });
  }
},

    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = this.sel_std_data.div_list;
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    putnull() {
      this.mainList = [];
      this.selectedTasks=[]
    },
    onload() {
      this.overlay = true;
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
          this.academicyear = res.data.sel_ay_data;
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getStudents() {
      this.selectedTasks=[]
      this.overlay = true;
      this.fetch_loader = true;
      const data = {
        divoff: this.div.div_off_id,
        ay:this.sel_ay_data.ay_id,
        standard:this.sel_std_data.std_id,
      };
      axios
        .post("/Admission/get_students_for_promote", data)
        .then((res) => {
          if (res.data.studentinfo.length != 0) {
            this.mainList = res.data.studentinfo;
            this.fetch_loader = false;
            this.overlay=false;
            this.show_card=true
          } else {
            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
            this.mainList = null;
            this.fetch_loader = false;
            this.overlay=false;
          }
        })
        .catch((error) => {
          // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
          this.overlay=false;
        })
        .finally(() => {
          this.fetch_loader = false;
          this.overlay=false;
        });
    },
    editItem(item) {
      this.editedIndex = this.studentinfo.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$store.commit("setldiv_id", this.editedItem.ldiv);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },    
  },
  watch:{
    mainList(newValue,oldValue){
    console.log( newValue);
    }      
    }
};
</script>
